module.exports = __webpack_public_path__ + "img/livemap_editbeacons_childbeaconsexample2.9368aa33.png";